import { render } from "./StartPractice.vue?vue&type=template&id=63684f88&scoped=true"
import script from "./StartPractice.vue?vue&type=script&lang=js"
export * from "./StartPractice.vue?vue&type=script&lang=js"

import "./StartPractice.vue?vue&type=style&index=0&id=63684f88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63684f88"]])

export default __exports__